<template>
  <div>
    <p class="dialog_describe">确认替换后，学员将收到对应的短信或者系统消息提醒。</p>
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      size="medium"
      label-width="100px"
    >
      <el-radio-group v-model="form.id" size="medium" class="mb20">
        <el-radio
          v-for="(item, index) in options"
          :key="index"
          :label="item.value"
          :disabled="item.disabled"
        >
          {{ item.label }}
        </el-radio>
      </el-radio-group>
      <el-form-item
        label="原因："
        label-width="70px"
        prop="deleted_remark"
        v-if="form.id == 2"
      >
        <el-input
          v-model="form.deleted_remark"
          placeholder="请输入原因"
          clearable
          :style="{ width: '100%' }"
        ></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //表单参数
      form: {
        id: 1,
        deleted_remark: "",
      },
      //表单校验
      formRules: {
        id: [
          {
            required: true,
            message: "移出班级不能为空",
            trigger: "change",
          },
        ],
        deleted_remark: [
          {
            required: true,
            message: "原因不能为空",
            trigger: "blur",
          },
        ],
      },
      //选项参数
      options: [
        {
          label: "非本班学员",
          value: 1,
        },
        {
          label: "其他",
          value: 2,
        },
      ],
    };
  },
  methods: {
    //提交表单
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$emit("change", this.form); //导出选择数据
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.remove_class {
  /deep/ .el-form {
    .el-input__inner {
      width: 100% !important;
    }
  }
  .dialog_describe {
    font-size: 14px;
    margin-bottom: 20px;
  }
}
</style>
